import { render, staticRenderFns } from "./addMeetingGroup.vue?vue&type=template&id=08644724&scoped=true&"
import script from "./addMeetingGroup.vue?vue&type=script&lang=js&"
export * from "./addMeetingGroup.vue?vue&type=script&lang=js&"
import style0 from "./addMeetingGroup.vue?vue&type=style&index=0&id=08644724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08644724",
  null
  
)

export default component.exports